import salesforceCrmReadmeMarkdown from '@/assets/Artifacts/README.md?raw'
import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME } from './nexusIntegrationsDemo.js'
import {
  ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_INITIAL,
} from './zohoCrmIntegrationDemoContent.part02.js'
import {
  ZOHO_CRM_INTEGRATION_BEFORE_BUILD_MARKDOWN,
  ZOHO_CRM_INTEGRATION_INTRO_MARKDOWN,
} from './zohoCrmIntegrationDemoContent.part01.js'
import { ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_BUILD } from './zohoCrmIntegrationDemoContent.part03.js'
import {
  ZOHO_CRM_INTEGRATION_ENDPOINT_TABLE_DATA,
  ZOHO_CRM_INTEGRATION_KEY_DESIGN_ITEMS,
  ZOHO_CRM_INTEGRATION_SUMMARY_BODY,
  ZOHO_CRM_INTEGRATION_SUMMARY_INTRO,
  ZOHO_CRM_INTEGRATION_WRAP_UP_MARKDOWN,
} from './zohoCrmIntegrationDemoContent.part04.js'

export function buildZohoCrmIntegrationFinalBlocks(artifactId) {
  return [
    { type: 'markdown', content: ZOHO_CRM_INTEGRATION_INTRO_MARKDOWN },
    {
      type: 'aiResponseLog',
      status: 'ok',
      showLogStatus: false,
      steps: buildWorkflowTimeline(ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_INITIAL),
    },
    { type: 'markdown', content: ZOHO_CRM_INTEGRATION_BEFORE_BUILD_MARKDOWN },
    {
      type: 'aiResponseLog',
      status: 'ok',
      showLogStatus: false,
      steps: buildWorkflowTimeline(ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_BUILD),
    },
    {
      type: 'fileArtifact',
      fileName: NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
      description: 'Markdown',
      artifactKind: 'doc',
      artifactId,
    },
    { type: 'markdown', content: ZOHO_CRM_INTEGRATION_SUMMARY_INTRO },
    { type: 'heading', level: 3, content: 'What Was Built' },
    { type: 'markdown', content: ZOHO_CRM_INTEGRATION_SUMMARY_BODY },
    { type: 'heading', level: 4, content: 'API Endpoints (all under /api/v1/salesforce/)' },
    { type: 'table', data: ZOHO_CRM_INTEGRATION_ENDPOINT_TABLE_DATA },
    { type: 'heading', level: 3, content: 'Key Design Choices' },
    { type: 'list', items: ZOHO_CRM_INTEGRATION_KEY_DESIGN_ITEMS },
    { type: 'markdown', content: ZOHO_CRM_INTEGRATION_WRAP_UP_MARKDOWN },
  ]
}

export function buildZohoCrmIntegrationArtifactPayload() {
  return {
    markdown: salesforceCrmReadmeMarkdown,
  }
}
